import type React from 'react';

import { Image, Link, Text } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate } from '@change-corgi/core-react/i18n';

import type { NewsAndGuidesListItem } from '#src/app/pages/newsAndGuides/list/pageContext';
import { useItemCard } from '#src/app/pages/newsAndGuides/list/shared/hooks';
import { Html } from '#src/app/shared/components/html';

type Props = {
	item: NewsAndGuidesListItem;
};

export const FeaturedCard: React.FC<Props & { ref?: React.RefObject<HTMLDivElement | null> }> = ({ item, ref }) => {
	const {
		data: { categoryName, targetUrl, photoUrl },
	} = useItemCard(item);
	const getStaticAssetUrl = useGetStaticAssetUrl();

	return (
		<div className="relative h-auto w-full pt-0 md:h-[310px] md:pt-6 lg:h-[360px] lg:pt-10" ref={ref}>
			<div className="static top-0 right-0 block h-60 w-full md:absolute md:h-full md:w-[65%] lg:w-[60%]">
				<Image
					src={photoUrl}
					fallback={
						<Image
							src={getStaticAssetUrl('/images/default-petition.gif')}
							alt=""
							className="rounded-small h-full w-full object-cover"
							loading="lazy"
							role="presentation"
						/>
					}
					alt=""
					className="rounded-small h-full w-full object-cover"
					loading="lazy"
					role="presentation"
				/>
			</div>

			<div className="rounded-small bg-fill-inverse-strong static w-full py-6 pr-2 pl-2 md:relative md:w-[66%] md:pr-[30px] md:pl-0">
				<Text as="span" fontWeight="bold" size="x-small" className="text-typography-weak uppercase">
					{categoryName}
				</Text>
				<Text as="h2" variant="heading" size="small" className="my-2">
					{item.title}
				</Text>
				<Text as="div" size="small" className="text-typography-weak">
					<Html as="div" html={item.excerpt} breakWord lineClamp={[null, 3]} />
				</Text>
				<Link href={targetUrl} className="mt-2" data-qa="card-read-more-link">
					<Translate value="fe.pages.news_index.read_more" />
				</Link>
			</div>
		</div>
	);
};
